import { useCallback } from 'react'
import authApi from '@/pages/Auth/auth.api.ts'

const useLogout = () => {
  return useCallback(() => {
    authApi.logout().then((r) => {
      if (r.status === 'success') {
        window.location.reload()
        localStorage.removeItem('access')
      }
    })
  }, [])
}

export default useLogout
